import { render, staticRenderFns } from "./BlogComponentsPage.vue?vue&type=template&id=8d220830&"
import script from "./BlogComponentsPage.vue?vue&type=script&lang=js&"
export * from "./BlogComponentsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports